import React from "react";
import { CrudPage } from "@/components/CrudPage";

const columns = [
  { key: "name", label: "会社名", render: (r) => <span className="font-medium">{r.name}</span> },
  { key: "contact_person", label: "担当者" },
  { key: "phone", label: "電話" },
  { key: "email", label: "メール" },
  { key: "work_types", label: "対応工事" },
];

const fields = [
  { name: "name", label: "会社名", required: true },
  { name: "contact_person", label: "担当者" },
  { name: "phone", label: "電話", type: "tel" },
  { name: "email", label: "メール", type: "email" },
  { name: "address", label: "住所", colSpan: 2 },
  { name: "work_types", label: "対応工事（カンマ区切り）", colSpan: 2 },
  { name: "note", label: "備考", type: "textarea" },
];

export default function Vendors() {
  return (
    <CrudPage
      title="業者管理"
      subtitle="修繕・工事業者の管理"
      endpoint="/vendors"
      resource="vendors"
      columns={columns}
      fields={fields}
      testid="vendors"
      addLabel="業者を登録"
      searchKeys={["name", "contact_person", "phone"]}
    />
  );
}
